module.exports = __webpack_public_path__ + "img/sent.f199f827.svg";